// LIBRARIES
import styled from "styled-components";

//MISC
import { COLORS, FONT_SIZE, FONT_WEIGHT } from "constants/variables";

//ASSETS
import cursorIcon from "assets/img/Cursor.png";

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PageNumber = styled.div<{
  active?: boolean;
  biggerCursor?: boolean;
}>`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0 4px;
  background-color: ${({ active }) =>
    active ? COLORS.VividAuburn : COLORS.Cultured};
  color: ${({ active }) => (active ? COLORS.Cultured : COLORS.MetalicSilver)};
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  &:hover {
    background-color: ${({ active }) =>
      active ? COLORS.FaluRed : `rgba(161, 161, 179, 0.5)`};
  }
`;

export const Dots = styled.div`
  margin: 0 5px;
  color: ${COLORS.MetalicSilver};
  font-size: ${FONT_SIZE.fix16};
  font-weight: ${FONT_WEIGHT.semiBold};
`;
